<form [formGroup]="form" (ngSubmit)="save()">
    <span class="float-end">
        <button type="submit" class="btn btn-primary d-print-none" [disabled]="!form.valid" i18n>Save</button>
        &nbsp;
        <div class="dropdown d-inline-block d-print-none">
            <button type="button" class="btn btn-secondary" data-bs-toggle="dropdown"><fa-icon
                    [icon]="fa.faEllipsis"></fa-icon></button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li *ngIf="user.id"><button type="button" class="dropdown-item" (click)="password()" i18n>Set
                        password</button></li>
            </ul>
        </div>
    </span>
    
    
    <h3><span i18n>Back office user</span> {{ user.first_name }} {{ user.last_name }}</h3>
    <span i18n>Created</span> {{ user.created_at | date: 'short' }} &bull; <span i18n>Modified</span> {{ user.updated_at
    | date: 'short' }}
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mt-4">
        <li [ngbNavItem]="'basics'">
            <button ngbNavLink i18n>Basics</button>
            <ng-template ngbNavContent>
                <div class="row g-3">
                    <div class="col-8">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label for="first_name" class="form-label" i18n>First name</label>
                                <input required
                                    [class.is-invalid]="form.get('first_name')?.invalid && form.get('first_name')?.touched"
                                    type="text" class="form-control" id="first_name" formControlName="first_name">
                            </div>
                            <div class="col-md-6">
                                <label for="last_name" class="form-label" i18n>Last name</label>
                                <input type="text" class="form-control" id="last_name" formControlName="last_name">
                            </div>
                            <div class="col-md-6">
                                <label for="email" class="form-label" i18n>Email</label>
                                <div class="input-group">
                                    <input required
                                        [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
                                        type="email" class="form-control" id="email" formControlName="email">
                                    <a class="btn btn-secondary" href="mailto:{{ user.email }}"><fa-icon
                                            [icon]="fa.faEnvelope"></fa-icon></a>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="mobile_pone" class="form-label" i18n>Mobile phone</label>
                                <div class="input-group">
                                    <input type="tel"
                                        [class.is-invalid]="form.get('mobile_phone')?.invalid && form.get('mobile_phone')?.touched"
                                        class="form-control" id="mobile_phone" formControlName="mobile_phone">
                                    <a class="btn btn-secondary" href="tel:{{ user.mobile_phone }}"><fa-icon
                                            [icon]="fa.faPhone"></fa-icon></a>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="type" class="form-label" i18n>Type</label>
                                <select class="form-select" id="type" formControlName="type">
                                    <option *ngFor="let type of userTypes | keyvalue" [value]="type.key">{{ type.value }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="row g-3">
                            <div class="col-12">
                                <label for="notes" class="form-label" i18n>Notes</label>
                                <textarea class="form-control" id="notes" rows="30" formControlName="notes"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="my-3"></div>
</form>